import { Flex, StarIcon } from "@fluentui/react-northstar";
import React from "react";
import { Tag } from "shared/models/Tag";
import TagLabel, { ReversedTagLabel } from "./TagLabel";
import { constants } from "shared/constants";

interface TagLabelsProps {
    tags: Tag[];
}

const prepareLabel = (tageCode: string) => {
    return tageCode.slice(constants.qualitySignCode.length);
};

const TagLabels: React.FC<TagLabelsProps> = (props: TagLabelsProps) => {
    return (
        <Flex wrap>
            {props.tags.map((tag, index) => {
                return tag.description.startsWith(constants.qualitySignCode) &&
                    tag.description.length > constants.qualitySignCode.length ? (
                    <ReversedTagLabel
                        headerIcon={<StarIcon outline size="smaller" style={{ color: `#${tag.color}` }} />}
                        tag={{ description: prepareLabel(tag.description), color: tag.color }}
                        key={`${tag.color}_${index}`}
                    />
                ) : (
                    <TagLabel tag={tag} key={`${tag.color}_${index}`} />
                );
            })}
        </Flex>
    );
};

export default TagLabels;
